import React from 'react';
import styled from 'styled-components';

/**
 * Information text for the "Standards conformance" field (#19675, ISO 14025:2026).
 * Compiler and Simple Wizard: a collapsible box whose header is the first sentence and whose body is the rest.
 * Copy group: tooltip on the field label, plain text.
 */

export const conformityStandardsInfoFirstSentence = 'A new version of ISO 14025 was released in 2026.';

/**
 * Full text without emphasis, paragraphs separated by a line break (Copy group tooltip, which takes a string).
 * Keep it in sync with ConformityStandardsInfoBody; the test compares the two.
 */
export const conformityStandardsInfoPlainText = [
  conformityStandardsInfoFirstSentence,
  'EPDs in the International EPD System that are based on a PCR version conforming with GPI 5 (so either GPI 5.0 or GPI 5.1) comply with this version (ISO 14025:2026).',
  'EPDs that are based on a PCR version conforming with GPI 4 or below do not comply with this new version ISO 14025:2026 but instead with the predecessor ISO 14025:2006.',
  'Important exception: EPDs under PCR 2019:14 version 2 or above need to indicate both versions (2006 and 2026) for compliance with EN 15804.',
  'Please select the correct ISO 14025 version for your EPD.',
  'To check which GPI version your chosen PCR version conforms with, open the relevant PCR document and check the information under "Standards and documents conformance" in its Section 2.1 Administrative information.',
].join('\n');

/** The paragraphs after the first sentence, with the emphasis of the design; the box renders the first sentence as its header. */
export const ConformityStandardsInfoBody: React.FC = () => (
  <Paragraphs>
    <p>
      EPDs in the International EPD System that are based on a PCR version conforming with GPI 5 (so either GPI 5.0 or GPI
      5.1) comply with this version (ISO 14025:<b>2026</b>).
    </p>
    <p>
      EPDs that are based on a PCR version conforming with GPI 4 or below do not comply with this new version ISO 14025:
      <b>2026</b> but instead with the predecessor ISO 14025:<b>2006</b>.
    </p>
    <p>
      <b>Important exception:</b> EPDs under <b>PCR 2019:14 version 2</b> or above need to indicate both versions (2006 and
      2026) for compliance with EN 15804.
    </p>
    <p>Please select the correct ISO 14025 version for your EPD.</p>
    <p>
      To check which GPI version your chosen PCR version conforms with, open the relevant PCR document and check the
      information under &quot;Standards and documents conformance&quot; in its Section 2.1 Administrative information.
    </p>
  </Paragraphs>
);

const Paragraphs = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  & p {
    margin: 0;
  }

  & b {
    font-weight: 600;
    font-style: normal;
  }
`;
